<template>
  <div class="mod-article-inner">
    <preview-job-content-header title="選考プロセス" />
    <ol class="mod-detail-step">
      <template v-for="(process,i) in processes">
        <li
          v-if="i != 0"
          :key="`arrow-${i}`"
          class="icon"
          :data-test="`arrow-${i}`"
        >
          <span class="arrow" />
        </li>
        <li :key="`process-${i}`">
          <p
            class="title"
            :data-test="`title-${i}`"
          >
            <span>STEP</span><span class="num">0{{ process.stepId }}</span>
          </p>
          <div class="inner">
            <p
              class="pega-pre-wrap"
              :data-test="`process-${i}`"
              v-text="process.value"
            />
          </div>
        </li>
      </template>
    </ol>
    <div v-if="entryProcess.processDetail.value">
      <p
        class="pega-pre-wrap"
        data-test="process-detail"
        v-text="entryProcess.processDetail.value"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/base" as *;
</style>

<script>
import PreviewJobContentHeader from '@/components/atoms/PreviewJobContentHeader'

export default {
  components: {
    PreviewJobContentHeader
  },
  props: {
    entryProcess: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    processes () {
      // USER側のスマホ表示がSTEP1は必須で表示するようになっているので、挙動を合わせる
      if (this.entryProcess.processes.some(process => process.stepId === 1)) {
        return this.entryProcess.processes
      } else {
        const processes = this.entryProcess.processes
        processes.unshift({ stepId: 1, value: '' })
        return processes
      }
    }
  }
}
</script>
